import React from "react";

const FleetCTA = () => {
  return (
    <section
      className="fleet-cta fleet-cta--two wow fadeInUp py-5"
      data-wow-duration="1500ms"
      data-wow-delay="300ms"
    >
      <div className="container">

        <div className="fleet-cta__inner">

          {/* Left Content */}
          <div className="fleet-cta__inner__item">

            <div className="sec-title">

              <h6 className="sec-title__tagline bw-split-in-right">
                Available 24/7
              </h6>

              <h3 className="sec-title__title bw-split-in-left">
                Call For Booking
              </h3>

            </div>

          </div>

          {/* Call Section */}
          <div className="fleet-cta__inner__item fleet-cta__inner__item--two">

            <div className="fleet-cta__inner__item__call">

              <a
                href="tel:+919529697070"
                className="fleet-cta__call"
              >

           

                {/* Content */}
                <div className="fleet-cta__call__content">

                  <span className="fleet-cta__call__text">
                    Aaradhya Travels
                  </span>

                  <h6 className="fleet-cta__call__number">
                    +91&nbsp;9529697070
                  </h6>

                </div>

              </a>

              {/* Background */}
              <div
                className="fleet-cta__inner__bg"
                style={{
                  backgroundImage:
                    "url('/images/shapes/background-cta.png')",
                }}
              ></div>

            </div>

          </div>

          {/* Button */}
          <div className="fleet-cta__inner__item">

            <a
              href="/booking"
              className="fleet-cta__inner__btn"
            >

              <span>Book now</span>

        <span>
  <i className="fa fa-arrow-right"></i>
</span>

            </a>

          </div>

        </div>

      </div>
    </section>
  );
};

export default FleetCTA;